'use client'

import {observer} from 'mobx-react'

import {Routes} from '@/src/config/routes'

import {NewsListContent} from '@/src/features/news-articles'
import {NewsPagination} from '@/src/features/news-articles/pagination/pagination'

import {useStore} from '@/src/shared/hooks/useStore'
import {sanitizeHtml} from '@/src/shared/utils/functions'
import noPhotoPic from '@/src/shared/assets/media/no-photo.png'

import * as UI from './screen.styled'
import {Alert} from 'antd'
import React from 'react'
import {PageData} from '@/src/core/domain/entities/page/page-data'

export const NewsScreen: React.FC<PageData<NewsListContent>> = observer(() => {
  const {pageData} = useStore<NewsListContent>()
  const content = pageData!.content

  const {news_list} = content

  return (
    <UI.Wrapper>
      <UI.Articles>
        {(news_list.items.length > 0 &&
          news_list.items.map(article => (
            <UI.ArticleContainer key={article.code}>
              <UI.NewsTile
                article={{
                  ...{
                    ...article,
                    cover: article.cover ? article.cover : {type: 'image', src: noPhotoPic.src},
                  },
                }}
                href={Routes.news.detail.page(article.code)}
                showTitle={false}
                datePlacement="left"
              />

              <UI.ArticleContent>
                <UI.NewsTileTitle href={Routes.news.detail.page(article.code)}>
                  {article.title}
                </UI.NewsTileTitle>
                <p>{article.date_create}</p>
                {article.preview && (
                  <UI.NewsTileDescription
                    dangerouslySetInnerHTML={{__html: sanitizeHtml(article.preview?.text)}}
                  />
                )}
              </UI.ArticleContent>
            </UI.ArticleContainer>
          ))) || <UI.Alert as={Alert} description="Нет статей" />}
      </UI.Articles>

      {content.news_list.pages > 1 && <UI.Pagination as={NewsPagination} />}
    </UI.Wrapper>
  )
})
